import React, { useState } from 'react'
import { FileInput, AlbumModel, AlbumTable, WINDOW_SIZE } from './Data'
import './App.css'
import { Faceoff } from './Faceoff';

function RYMLink() {
  return (
    <a
      href="https://rateyourmusic.com/"
      target="_blank"
      rel="noopener noreferrer"
    >Rate Your Music</a>
  );
}

function BradleyTerryLink() {
  return (
    <a
      href="https://en.wikipedia.org/wiki/Bradley%E2%80%93Terry_model"
      target="_blank"
      rel="noopener noreferrer"
    >Bradley-Terry model</a>
  );
}

function ELOLink() {
  return (
    <a
      href="https://en.wikipedia.org/wiki/Elo_rating_system"
      target="_blank"
      rel="noopener noreferrer"
    >ELO</a>
  );
}

function GwernLink() {
  return (
    <a
      href="https://www.gwern.net/Links"
      target="_blank"
      rel="noopener noreferrer"
    >Gwern</a>
  );
}

function ResorterLink() {
  return (
    <a
      href="https://www.gwern.net/Resorter"
      target="_blank"
      rel="noopener noreferrer"
    ><code>resorter</code></a>
  );
}

function NoisySortingLink() {
  return (
    <a
      href="https://www.gwern.net/Resorter#noisy-sorting"
      target="_blank"
      rel="noopener noreferrer"
    >noisy-sorting</a>
  );
}

function MaxBoLink() {
  return (
    <a
      href="https://maxbo.me"
    >Max Bo</a>
  );
}

function ProfileLink(props: { username?: string }) {
  if (!props.username) {
    return <>profile</>
  }

  const link = `https://rateyourmusic.com/~${props.username}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >profile</a>
  );
}

function RatingsLink(props: { username?: string }) {
  if (!props.username) {
    return <>your RYM ratings</>
  }

  const link = `https://rateyourmusic.com/collection/${props.username}/r0.5-5.0`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >your RYM ratings</a>
  );
}

function Header() {
 return <header>
   <h1>Rank Your Music</h1>
   <h3>Interactive resorting of <RYMLink/> ratings with a <BradleyTerryLink /></h3>
 </header>
}

function Description() {
  return <blockquote>
    User-created datasets using ordinal scales (such as media ratings) have 
    tendencies to drift or 'clump' towards the extremes and fail to be 
    informative as possible, falling prey to ceiling effects and making it 
    difficult to distinguish between the mediocre and truly excellent.
    <br /><br />
    This can be counteracted by rerating the dataset to create a uniform 
    (and hence, informative) distribution of ratings, but such manual 
    rerating is difficult.
    <br /><br />
    This app owe's itself to <GwernLink />'s <ResorterLink />, 
    which keeps track of comparisons, infers underlying ratings assuming that 
    they are noisy in the <ELOLink/>-like <BradleyTerryLink />, 
    and interactively &amp; intelligently queries the user with comparisons 
    of the media with the most uncertain current ratings, and outputting 
    a fully rescaled set of ratings when the user ends the session. 
    Gwern has also done a huge amount of work compiling <NoisySortingLink /> literature, 
    to which I sincerely extend my thanks.
  </blockquote>
}

function Usage() {
  const [username, setUsername] = useState<string>();
  const [albums, setAlbums] = useState<AlbumModel[]>();

  const usernameInput =
    <input
      value={username}
      placeholder={"e.g. theneedledrop"}
      onChange={e => setUsername(e.target.value)}
    />;


  const lengthHint = albums && albums.length > WINDOW_SIZE && 
    <>and {albums.length - WINDOW_SIZE} other rows. We really don't need to see the whole 
    list (you have <RatingsLink username={username} /> for that).</>

  return (
    <>
      <h2>Usage</h2>

      <section>
        <h4>Enter your <RYMLink /> username</h4>
        {usernameInput}
      </section>

      <section>
        <h4>Go to your <ProfileLink username={username}/></h4>
        and click <code>Export your data</code>. Save it somewhere to be uploaded.
      </section>

      <section>
        <h4>Upload your data</h4>
        <FileInput onParsed={setAlbums} />
        {albums 
          ? <AlbumTable albums={albums} />
          : <p>We'll show a slice of this data after you've loaded it as a sanity check.</p>
        }
        {lengthHint}
      </section>


      <section>
        <h4>Answer some questions</h4>
        {albums
          ? <Faceoff albums={albums} />
          : <p>After you've loaded the data, we'll do pairwise comparisons of albums.</p>
        }
      </section>
    </>
  );
}

function Footer() {
  return (
    <>
    <hr />
      <footer>
        <p><MaxBoLink /> c. 2020</p>
      </footer>
    </>
  )
}

function App() {
  return (
    <>
      <Header />
      <Description />
      <Usage />
      <Footer />
    </>
  );
}

export default App
